import * as React from 'react';
import CardRegister from '../../components/cardRegister';
import TotalCost from '../../components/totalCost';
import CurrentPlan from './currentPlan';
import { CheckoutProps } from '../checkout/models';

export interface CardRegisterWrapperProps extends Pick<CheckoutProps, 'model' | 'onChange'> {
	allowEdit?: boolean;
}

export default class CardRegisterWrapper extends React.Component<CardRegisterWrapperProps> {
	public render() {
		return (
			<CardRegister>
				<div className="left">{this.props.children}</div>
				{this.props.model && this.props.model.price && (
					<div className="right">
						<CurrentPlan price={this.props.model.price} />
						<div className="hRule" />
						<TotalCost
							allowEdit={this.props.allowEdit}
							coupon={this.props.model.coupon}
							numberOfGlasses={this.props.model.numberOfGlasses!}
							onQuantityChanged={this.onQuantityChanged}
							overridePriceAmount={this.props.model.overrideProductPrice}
							price={this.props.model.price.price}
							quantity={this.props.model.quantity}
						/>
					</div>
				)}
			</CardRegister>
		);
	}
	private onQuantityChanged = (quantity: number) => {
		this.props.onChange({ quantity: quantity });
	};
}
